<template>
  <v-container fluid class="home-container">
    <section>
      <v-row align="center" class="home-row">
        <v-col cols="12" sm="5">
          <v-row align="center" no-gutters class="home-title-row">
            <span class="home-title">
              L’art de vous simplifier la tâche
            </span>
          </v-row>
          <v-row align="center" no-gutters class="home-subtitle-row">
            <span class="home-subtitle">
              GesKitchen est bien plus qu’un système innovant de gestion
              d’inventaire, c’est un outil pour animer votre cuisine, en assurer
              rondement les opérations de manière simple et efficace. Découvrir
              ses multiples fonctionnalités, c’est l’adopter.
            </span>
          </v-row>
          <v-row
            align="center"
            :justify="$vuetify.breakpoint.smAndUp ? 'start' : 'center'"
            no-gutters
            class="home-button-row"
          >
            <v-btn
              rounded
              large
              :elevation="0"
              color="#FFB300"
              class="home-button"
              :to="{ name: 'Contact' }"
            >
              <span class="font-capitalize">Nous contacter</span>
            </v-btn>
            <v-btn
              rounded
              outlined
              large
              :to="{ name: 'Features' }"
              class="home-button ml-3"
            >
              <span class="font-capitalize font-weight-light"
                >En savoir plus</span
              >
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="0" sm="7" v-if="$vuetify.breakpoint.smAndUp">
          <div class="home-design"></div>
        </v-col>
      </v-row>
    </section>
    <section style="margin: 7rem 0;" class="detail-section">
      <v-row justify="space-between">
        <v-col cols="12" sm="3">
          <v-row align="center" no-gutters>
            <svg width="70" height="70">
              <rect
                x="5"
                y="5"
                width="60"
                height="60"
                stroke="#FFB300"
                fill="transparent"
                stroke-width="5"
                stroke-linejoin="round"
              />
            </svg>
          </v-row>
          <v-row align="start" no-gutters class="detail-title-row ">
            <span class="detail-title">
              Ajustement automatique de votre inventaire
            </span>
          </v-row>
          <v-row align="start" no-gutters class="detail-subtitle-row">
            <span class="detail-subtitle">
              Sachez toujours exactement ce qu’il vous reste en stock.
            </span>
          </v-row>
        </v-col>
        <v-col cols="12" sm="3">
          <v-row
            align="center"
            :justify="$vuetify.breakpoint.smAndUp ? 'start' : 'end'"
            no-gutters
          >
            <svg width="70" height="70">
              <polygon
                points="5 65, 35 5, 65 65"
                fill="transparent"
                stroke="#FFB300"
                stroke-width="5"
                stroke-linejoin="round"
              />
            </svg>
          </v-row>
          <v-row
            align="start"
            :justify="$vuetify.breakpoint.smAndUp ? 'start' : 'end'"
            no-gutters
            class="detail-title-row "
          >
            <span class="detail-title">
              Respect de votre cost selon vos besoins réels
            </span>
          </v-row>
          <v-row
            align="start"
            :justify="$vuetify.breakpoint.smAndUp ? 'start' : 'end'"
            no-gutters
            class="detail-subtitle-row"
          >
            <span class="detail-subtitle">
              Finies les commandes excessives! Tout pour que vous puissiez
              éviter les pertes.
            </span>
          </v-row>
        </v-col>
        <v-col cols="12" sm="3">
          <v-row align="center" no-gutters>
            <svg width="70" height="70">
              <circle
                cx="35"
                cy="35"
                r="30"
                fill="transparent"
                stroke="#FFB300"
                stroke-width="5"
                stroke-linejoin="round"
              />
            </svg>
          </v-row>
          <v-row align="start" no-gutters class="detail-title-row ">
            <span class="detail-title">
              Simplification des commandes et listes de préparation
            </span>
          </v-row>
          <v-row align="start" no-gutters class="detail-subtitle-row">
            <span class="detail-subtitle">
              Pas d’erreurs possibles. GesKitchen vous accompagne à chaque
              étape.
            </span>
          </v-row>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="center"
        no-gutters
        style="margin-top: 4rem;"
      >
        <v-btn
          rounded
          large
          :elevation="0"
          color="#FFB300"
          :to="{ name: 'Features' }"
          class="home-button"
        >
          <span class="font-capitalize">Découvrir</span>
        </v-btn>
      </v-row>
    </section>
  </v-container>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style lang="scss" scoped>
.home-container {
  margin-top: 3rem;
  margin-bottom: 3rem;
  .home-title-row {
    margin-top: 3rem;
    .home-title {
      line-height: 1.2;
      font-size: 3rem;
      font-weight: 500;
    }
  }
  .home-row {
    background-color: rgba(0, 0, 0, 0.03);
    border-radius: 0 0 50rem 0;
    padding: 0.5rem;
  }
  .home-subtitle-row {
    margin-top: 4rem;
    .home-subtitle {
      line-height: 1.8;
      font-size: 1.1rem;
    }
  }
  .home-button-row {
    margin-top: 4rem;
    margin-bottom: 3rem;
  }
  .home-button {
    width: 160px;
  }
  .home-design {
    height: 30rem;
    width: 50vw;
    margin-left: 10rem;
    background-color: rgba(0, 0, 0, 0.03);
    border-radius: 0 0 0 50rem;
  }
  .detail-section {
    padding: 2rem;
    .detail-title-row {
      margin-top: 2rem;
      .detail-title {
        line-height: 1.2;
        font-size: 1.5rem;
        font-weight: 500;
      }
    }
    .detail-subtitle-row {
      margin-top: 1.8rem;
      .detail-subtitle {
        font-size: 1rem;
      }
    }
  }
}

@media screen and (min-width: 600px) {
  .home-container {
    .home-row {
      background-color: #fff;
      border-radius: 0 0 0 0;
      padding: 0;
    }
    .detail-section {
      padding: 0;
    }
  }
}
</style>
